import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Icon, Input, Col, Table } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
import { RightsWrapper } from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
@Form.create()

class AllTaxes extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    taxType: '',
    countryArr: [],
    editItem: [],
    taxTypeArray: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getTaxDetails({
        ...params,
        regExFilters: []
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }
  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        values.taxTypeArray = this.state.taxTypeArray;
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateTaxDetails(values)
        } else {
          x = await Request.addTaxDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Tax Detail Updated Successfully`
              : 'Tax Detail Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteTaxDetails = async data => {
    this.setState({ loading: true })
    await Request.deleteTaxDetails(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setTaxDetailsData(companyDetailId) {
    if (companyDetailId) {
      Request.financeTaxDetailsByID({ id: companyDetailId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1',
              taxTypeArray: doc.taxTypeArray
            })

            this.props.form.setFieldsValue({
              taxTitle: doc.taxTitle,
              countryId: doc.countryId,
              taxTypeArray: doc.taxTypeArray,
              taxStatus: doc.taxStatus
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  loadCountry() {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
      businessId: activeUser && activeUser.businessId
    };
    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          _.each(resp.data, (vv) => {
            temp.push({
              display: vv.countryName,
              id: vv._id,
            });
          });
          this.setState({ countryArr: temp });
        }
      })
      .catch((err) => {
      });
  }

  componentWillMount() {
    this.loadCountry()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {
      form: { getFieldDecorator }
    } = this.props
    const { countryArr, id, taxTypeArray, editItem } = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Tax Title',
          key: 'taxTitle'
        },
        {
          label: 'Select Country ',
          key: 'countryId',
          required: true,
          type: 'select',
          showSearch: true,
          disabled: false,
          options: countryArr,
          onChange: v => {
            this.props.form.setFieldsValue({
              countryId: v
            })
          }
        },
        {
          label: 'Status',
          key: 'taxStatus',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Active', 'Inactive'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              taxStatus: v
            })
          }
        },
        {
          label: 'Tax Type',
          key: 'taxTypeKeyWord',
          customProps: {
            style: {
              width: '75%'
            }
          },
          rightComp: <Button style={{ marginLeft: '3px' }} type="primary" onClick={() => {
            let taxType = this.props.form.getFieldValue('taxTypeKeyWord');
            let taxTypeArray = this.state.taxTypeArray;
            taxTypeArray.push({
              taxName: taxType,
              taxValue: 0
            })
            this.setState({ taxTypeArray });
          }}>{<Icon type="plus" />}</Button>
        }
      ]
    };

    const columns = [
      {
        title: 'Tax Title',
        key: 'taxTitle'
      },
      {
        title: 'Country Name',
        key: 'countryName',
      },
      {
        title: 'Tax Type',
        key: 'taxTypeArray',
        render: (item, record, index) => {
          return (<div>
            {
              record.taxTypeArray && record.taxTypeArray.map((tax, index) => {
                return (
                  <div key={index}><b>{tax.taxName}:- </b>{tax.taxValue}</div>
                )
              })
            }
          </div>)
        }
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'financeTax.edit'}>
              <Tooltip title="Edit Tax">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setTaxDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'financeTax.delete'}>
              <Tooltip title="Delete Tax">
                <Popconfirm
                  title="Are you sure delete this Tax?"
                  onConfirm={() => {
                    this.deleteTaxDetails({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ];
    let taxColumns = [
      {
        title: 'Tax Name',
        key: 'taxName',
        render: (text, record) => {
          return (
            <div>{record.taxName}</div>
          )
        }
      },
      {
        title: 'Value',
        key: 'taxValue',
        dataIndex: 'taxValue',
        render: (item, record, index) => {
          return (<div>
            <Input type='tax' onChange={(e) => {
              taxTypeArray[index].taxValue = e.target.value;
              this.setState({ taxTypeArray });
            }} value={record.taxValue} />
          </div>)
        }
      }
    ]
    return (
      <PageHeaderWrapper title={` Tax Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Details`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Tax Detail'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                {
                  taxTypeArray && taxTypeArray.length > 0 &&
                  <Col span={18} offset={6} className={styles.bgTableBox}>
                    <Table
                      rowKey={(item, x) => {
                        return x
                      }}
                      className={styles.claimEdit}
                      dataSource={taxTypeArray || []}
                      columns={taxColumns}
                      pagination={false}
                      border={true}
                    />
                  </Col>
                }
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllTaxes
